/**
 * `HH:MM:SS` with uncapped hours (`104:03:07`), locale-independent — the form Excel understands
 * as a duration. Distinct from the `2h 15m` display form used on screen and in the PDF.
 */
export function formatDurationHms(totalSeconds: number): string {
  const safe = Number.isFinite(totalSeconds) ? Math.max(0, Math.round(totalSeconds)) : 0;
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}
